import { useAuth0 } from '@auth0/auth0-react';
import { CollapsibleSidebarAndMainContent } from '@strata/react-collapsible-sidebar-and-main-content';
import { LeftSideNav } from '@strata/react-left-side-navbar';
import { type ComponentProps } from 'react';
import { Outlet } from 'react-router';

import { AppRoutes } from 'services/routes';

interface SidebarPageLayoutProps {
    navTabContent: ComponentProps<typeof LeftSideNav>['navTabContent'];
}

export const SidebarPageLayout = ({ navTabContent }: SidebarPageLayoutProps) => {
    const { user, logout } = useAuth0();

    const onLogOutClick = () => {
        void (async () => {
            sessionStorage.clear();
            pendo.clearSession?.(); // Optional chaining to avoid error if pendo is not initialized
            await logout({
                logoutParams: { returnTo: `${window.location.origin}${AppRoutes.loggedOut}` },
            });
        })();
    };

    return (
        <div style={{ height: '100vh' }}>
            <CollapsibleSidebarAndMainContent
                sidebarContent={
                    <LeftSideNav
                        navTabContent={navTabContent}
                        homeNavLink={{
                            label: 'Back to Home',
                            to: AppRoutes.home,
                        }}
                        loggedInUser={user?.name}
                        onLogOutClick={onLogOutClick}
                        fmhEnvironmentForTag={process.env.REACT_APP_ENV}
                    />
                }
                mainContent={<Outlet />}
                noSidebarPadding
            />
        </div>
    );
};
